import { render } from "./WordReading.vue?vue&type=template&id=55f048d4&scoped=true"
import script from "./WordReading.vue?vue&type=script&lang=js"
export * from "./WordReading.vue?vue&type=script&lang=js"

import "./WordReading.vue?vue&type=style&index=0&id=55f048d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f048d4"]])

export default __exports__